export default "__VITE_ASSET__a77f25f7__"